import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { privacyApi } from '../../../services/privacyApi';
import { logger } from '../../../utils/logger';
import { TrashIcon, AlertIcon } from './Icons';

export default function TravelDataCard() {
    const { t } = useTranslation();
    const [status, setStatus] = useState<'idle' | 'deleting' | 'success'>('idle');

    const handleDelete = async () => {
        const confirmed = window.confirm(t('privacy.delete_confirm_msg'));

        if (!confirmed) return;

        setStatus('deleting');
        try {
            await privacyApi.deleteOwnedTrips();
            setStatus('success');
            setTimeout(() => setStatus('idle'), 5000);
        } catch (err) {
            logger.error('Failed to delete trips', err);
            setStatus('idle');
            alert(t('privacy.failed_delete_trips'));
        }
    };

    return (
        <div className="privacy-card">
            <div className="card-header">
                <div className="header-icon trash">
                    <TrashIcon size={20} />
                </div>
                <h3>{t('privacy.travel_data_control')}</h3>
            </div>
            <p className="card-subtitle">{t('privacy.delete_history_subtitle')}</p>

            <div className="action-notice warning">
                <AlertIcon size={14} />
                <span>{t('privacy.snapshots_preserved')}</span>
            </div>

            <button
                className={`btn-danger-outline ${status === 'success' ? 'success' : ''}`}
                onClick={handleDelete}
                disabled={status === 'deleting'}
            >
                {status === 'idle' && t('privacy.delete_private_trips')}
                {status === 'deleting' && t('privacy.deleting')}
                {status === 'success' && t('privacy.data_deleted')}
            </button>
        </div>
    );
}
